import React from 'react';
import Modal, { ModalHeader } from '../Modal';
import TaskSelectedList from './TaskSelectedList';

const TaskLoad = ({ open, setOpen, task, useFormItem, setTaskData }) => {
  const cancel = (e) => {
    if (e) e.preventDefault();
    setOpen(false);
  };
  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`${task.label} 불러오기`}
        </ModalHeader>
        <TaskSelectedList
          task={task}
          useFormItem={useFormItem}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default TaskLoad;